<ng-container *ngIf="!!get && !!delivery">
    <tt-card>
        <tt-select ttLabel="consignment_name" [(ttModel)]="delivery.consignment_keyno" (ttModelChange)="readGrid()" [ttData]="consignments">
            <tt-form-field-button
                *ngIf="delivery.consignment_keyno > '0'"
                buttons
                ttIcon="fas fa-chevron-right"
                ttTooltip="goto_consignment"
                [ttTranslateTooltip]="true"
                ttGoto="consignment"
                [ttGotoParms]="{ consignment_keyno: delivery.consignment_keyno }"
            ></tt-form-field-button>
        </tt-select>
    </tt-card>
    <tt-grid *ngIf="!!grid" [(ttOptions)]="grid"></tt-grid>
</ng-container>
